module.exports = __webpack_public_path__ + "img/90.191c147f.jpg";